import React, { useContext, useMemo } from 'react';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import classNames from 'classnames';
import { ServiceRequestContext } from '@/context/serviceRequestContext';

export interface RequestCardProps {
  classNames?: string;
  onClickHandler: Function;
  activeIndex: number;
  index: number;
  data: {
    id: string;
    name: string;
    value: string;
    displayName: string;
  };
  localServiceType: string;
}

const background = 'linear-gradient(180deg, #434343 0%, #CFCFCF 100%)';

export const RequestCard = (props: RequestCardProps) => {
  const { data, onClickHandler, activeIndex, index } = props;
  const { state: serviceState } = useContext(ServiceRequestContext);

  const typeWithoutId = () => {
    const splitString = data.id.split('-');
    if (splitString.length === 3) {
      return (splitString[1] + splitString[2])?.toLowerCase();
    } else {
      return splitString[1]?.toLowerCase();
    }
  };

  const isSelected = useMemo(() => {
    if (
      (serviceState.defectType != '' && data.name == serviceState.defectType) ||
      activeIndex === index
    ) {
      return true;
    }
    return false;
  }, [serviceState, index, activeIndex, data.name]);

  return (
    <Div
      className="p-px rounded-cm bg-neutral-50 cursor-pointer"
      style={
        isSelected
          ? {
              background,
            }
          : {}
      }
    >
      <Div className="bg-white rounded-cm">
        <Div
          data-testid={activeIndex === index ? 'active-' + typeWithoutId() : typeWithoutId()}
          onClick={() => onClickHandler()}
          className={classNames('p-4 h-[88px] w-full bg-white  rounded-cm  flex-1 ', {
            ' border-gray-400 shadow-medium': isSelected,
            'hover:bg-light-blue-100 hover:border-black hover:border-1  bg-white':
              activeIndex !== index,
          })}
          style={
            isSelected
              ? {
                  background: 'linear-gradient(127.01deg, #E8F2FF 10.96%, rgba(232, 242, 255, 0)',
                }
              : {}
          }
        >
          <Div className="flex flex-wrap">
            <Paragraph
              size="lg"
              className={classNames('text-black/70', {
                'font-bold': isSelected,
              })}
            >
              {data.name}
            </Paragraph>
          </Div>
        </Div>
      </Div>
    </Div>
  );
};
